import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
} from '@angular/core';

@Component({
  selector: 'app-tabs',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss',
})
export class TabsComponent implements OnInit {
  @Input() tabs: {
    label: string;
    contentTemplate: TemplateRef<any>;
    context?: { index: number };
  }[] = [];
  @Input() initialSelectedTab: number = 0;
  @Input() selectedTab: number = 0;
  @Output() tabChange = new EventEmitter<number>();

  ngOnInit(): void {
    if (
      this.initialSelectedTab >= 0 &&
      this.initialSelectedTab < this.tabs.length
    ) {
      this.selectedTab = this.initialSelectedTab;
    }
  }

  selectTab(index: number) {
    if (this.selectedTab !== index) {
      this.selectedTab = index;
      this.tabChange.emit(this.selectedTab);
    }
  }
}
